import React from "react";

import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";

import TerminalsTable from "./components/tables/TerminalsTable";
import TerminalOrdersTable from "./components/tables/TerminalOrdersTable";

const TABS = [
  {
    eventKey: "assigned",
    title: "In Store",
  },
  {
    eventKey: "inventory",
    title: "Inventory",
  },
  {
    eventKey: "orders",
    title: "Terminal Orders",
  },
];

export default class Terminals extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeKey: TABS[0].eventKey,
    };
  }

  handleSelect = (key) => {
    this.setState({ activeKey: key });
  };

  render() {
    const { activeKey } = this.state;

    return (
      <div className="terminals">
        <Tabs
          id="terminals-tabs"
          activeKey={activeKey}
          onSelect={this.handleSelect}
          className="v2"
        >
          {TABS.map((tab) => (
            <Tab eventKey={tab.eventKey} title={tab.title} key={tab.eventKey} />
          ))}
        </Tabs>
        {
          ["assigned", "inventory"].includes(activeKey) &&
          <TerminalsTable
            mode={activeKey}
          />
        }
        {
          activeKey === "orders" &&
          <TerminalOrdersTable/>
        }
      </div>
    );
  }
}
